export default "__VITE_ASSET__Covi81pd__"